import request from '@/plugin/axios'

/**
 * 查询电表列表
 * @param params
 * @returns {*}
 */
export function getAllDevicesBasedOnCondition (params) {
  return request({
    url: '/v1/electricity/acFeeDetails/getAllDevicesBasedOnCondition',
    method: 'get',
    params
  })
}

/**
 * 查询空调列表
 * @param params
 * @returns {*}
 */
export function queryAcFeeDetailsAllByLimit (params) {
  return request({
    url: '/v1/electricity/acFeeDetails/queryAcFeeDetailsAllByLimit',
    method: 'get',
    params
  })
}

/**
 * 执行换表操作
 * @param data
 * @returns {*}
 */
export function airConditioningElectricityApportionment (data) {
  return request({
    url: '/v1/electricity/acFeeDetails/airConditioningElectricityApportionment',
    method: 'post',
    data
  })
}

/**
 * 执行换表操作
 * @param data
 * @returns {*}
 */
export function deleteAirConditionedRoomBinding (data) {
  return request({
    url: '/v1/electricity/acFeeDetails/deleteAirConditionedRoomBinding',
    headers: {
      'Content-Type': 'x-www-form-urlencoded'
    },
    method: 'delete',
    params: data
  })
}

